import React, { useState } from 'react';
import { SubmenuContainer } from '../../general_components/forms/input_fields/loadStopsInput';
import styled from 'styled-components';
import { RemoveButton, AddButton } from '../../general_components/content_management/reusableItems/buttons';
import { OptionsContainer, OptionSubPart, SuggestedOption } from '../../general_components/forms/input_fields/inputFieldDelegate';
import { API_ROOT, sendRequest } from '../../supplementary_components/requests';

const EmployeeField = styled.div`
    display:grid;
    grid-template-columns: 1fr 1.5rem;
    &>:first-child{
        margin-right:0.5rem;
    }
`;
//

export const SelectingMultipleEmployeesForTeams = ({defaultData, nameFormatter, currentTeamId}) => {
    
    let initialData = [{name:""}];
    if(defaultData){
        initialData = [];
        for (const member of defaultData()){
            initialData.push(
                {
                    name: nameFormatter(member).value,
                    suggestionsList: null,
                    initValue:JSON.stringify(member)
                }
            )
        }
// {name: 'Asad (Asadulloh)', suggestionsList: null}
    }
    const [members, setMembers] = useState(initialData)//,{null:true}
    const _setMembers = (val) => {
        setMembers(val)
    }
    // const [suggestionsList, setSuggestionsList] = useState(initialState)
    const updateDataset = (event, onBlur)=>{
        const data = [...members]
        const index = parseInt(event.target.getAttribute('data-index'));
        data[index]["name"] = event.target.value;
        if(event.target.value === ""){
            data[index]["suggestionsList"] = null;
        }
        _setMembers(data);
        if(event.target.value !== ""){
            sendRequest('GET', API_ROOT+"teams/dispatchByNameWithTeamInfo?pattern="+event.target.value.trim(), null, (value)=>{
                // props.customCheckTrigger(value, customOnChange, props.fieldName, false)
                const data = [...members]
                if(Array.isArray(value) && value.length > 0){ 
                    data[index]["suggestionsList"] = value;
                }else{
                    data[index]["suggestionsList"] = null;
                }
                _setMembers(data);
                // else{
                //     e.target.nextSibling.style.display = 'none';  
                // }
                // customOnChange(value, "suggestionsList", null, false);   
            }, null, null); 
        }
    }
    const resetEmployeeField = (event) => {
        event.target.setAttribute('data-value', '');
        const data = [...members]
        const index = parseInt(event.target.getAttribute('data-index'));
        data[index]["name"] = "";
        data[index]["suggestionsList"] = null;
        _setMembers(data);
    }
    const onBlur = (event) => { 
        const target = event.target;
        for (const child of target.nextSibling.childNodes[0].childNodes){
            if(child.matches(':hover')){
                const parsedRawVal = JSON.parse(child.getAttribute("data-raw-val"))
                if(parsedRawVal && (parsedRawVal.available === false && parsedRawVal.teamId !== currentTeamId)){
                    target.focus();
                    return
                }
                target.setAttribute('data-value', child.getAttribute('data-raw-val'));
                if(target.className.includes('subError')){
                    target.className = target.className.replace('subError', '') ;
                }
                const data = [...members]
                const index = parseInt(event.target.getAttribute('data-index'));
                data[index]["name"] = nameFormatter(parsedRawVal).value;
                data[index]["suggestionsList"] = null;
                _setMembers(data);
                return;
            }
        }
        
        let selected = false;
        if(target.value !== ''){
            let itemName = target.value.trim().substr(0, target.value.trim().indexOf(" ("));
            sendRequest('GET', API_ROOT+"teams/dispatchByNameWithTeamInfo?pattern="+itemName, null, (value)=>{
                for (const entry of value){
                    const  formattedName = nameFormatter(entry);
                    if (formattedName.value === target.value.trim()){
                        if((entry.available === false && entry.teamId !== currentTeamId ) || members.filter(item => item.name === formattedName.value).length > 1){
                            resetEmployeeField(event)
                            return;
                        }
                        selected = true;
                        target.value = target.value.trim();
                        target.setAttribute('data-value', JSON.stringify(entry));
                        if(target.className.includes('subError')){
                            target.className = target.className.replace('subError', '') ;
                        }
                        return
                    }
                } 
                if(!selected){
                    resetEmployeeField(event);
                }else{
                    // setAndRemoveError(column, target, null, false);
                }
            },()=>{
                resetEmployeeField(event);
            }, null); 
        }else{
            resetEmployeeField(event);
        }
    }
    const removeMember = (index) =>{
        const data = [...members]
        data.splice(index, 1);
        _setMembers(data);
    }
    return <SubmenuContainer>
        <div>
            <span id="teamMembersList">
                {members.map((value, index)=>{
                    return <EmployeeField key={index}>
                        <span>
                            <input 
                                data-index={index} 
                                name='member' 
                                value={value.name?value.name:""} 
                                placeholder="Member 1" 
                                onChange={updateDataset}
                                onBlur={
                                    onBlur
                                }
                                data-value={value.initValue ? value.initValue : null}
                            /> 
                            <OptionsContainer id={'employeeOptions'} style={{display:value['suggestionsList']?'block':'none'}}  >
                                <div>
                                    {value['suggestionsList']?value['suggestionsList'].map((option, index)=>{
                                        const formattedName = nameFormatter(option)
                                        if(members.filter(item => item.name === formattedName.value).length > 0 ) {
                                            return null
                                        }
                                        
                                        return <SuggestedOption 
                                            key={index} 
                                            style={{cursor:option.available === false && option.teamId !== currentTeamId?'not-allowed':''}} 
                                            data-raw-val={JSON.stringify(option)}>
                                                {formattedName.value} 
                                                <OptionSubPart>{formattedName.subPart}</OptionSubPart>
                                        </SuggestedOption>
                                    }):null}
                                </div>
                            </OptionsContainer>
                        </span>
                        
                        <RemoveButton disabled={members.length === 1}  action={()=>{removeMember(index)}} />
                    </EmployeeField>
                        
                })}
                
                <AddButton customSize={"1.4rem"} action={()=>{
                    const membersArrayCopy = [...members];
                    membersArrayCopy.push({});
                    _setMembers(membersArrayCopy);
                }} />
            </span>
        </div>
    </SubmenuContainer>

}